/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Tabulation = styled.div`
  position: relative;
  ${t.mixins.flex()}
  width: 100%;
  padding: 9px 0 13px 0;
  background-color: ${t.color.white};
  border-color: ${t.color.greyAlto};
  border-style: solid;
  border-width: 1px;
  color: ${t.color.greyAlto};

  ${t.mixins.sm(`
    display: none;
  `)}

  ${({ active }) =>
    active &&
    `
    padding: 15px 0 13px 0;
    color: ${t.color.primary};
    border-width: 1px 1px 0 1px;
    &:before {
      content: "";
      position: absolute;
      top: -6px;
      left: -1px;
      right: -1px;
      height: 6px;
      background-color: ${t.color.primary};
    }

    ${t.mixins.sm(`
      ${t.mixins.flex()}
      border-width: 0 0 1px 0;
      border-color: ${t.color.greyMercury};
      padding: 20px 0 32px 0;
      background-color: transparent;
      &:before {
        display: none;
      }
    `)}
  `}
`;

const Title = styled.span`
  position: relative;
  font-family: ${t.font.primary};
  font-weight: ${t.font.bold};
  text-transform: uppercase;
  ${t.mixins.rem(16, 20)}
`;

const Notch = styled.img.attrs({ src: t.image.notchRound })`
  position: absolute;
  right: -35px;
`;

const Border = styled.div`
  background-color: ${t.color.primary};
`;

/**
 * tabulation component is..
 */

const Form__tabulation = ({ style, title, active, completed }) => (
  <React.Fragment>
    {active && <Border />}
    <Tabulation style={style} active={active}>
      <Title>
        {title}
        {(active || completed) && <Notch />}
      </Title>
    </Tabulation>
  </React.Fragment>
);

export default Form__tabulation;

Form__tabulation.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
  /**
      True if tabulation is the current step
      */
  active: PropTypes.bool,
  /**
      Tabulation title
      */
  title: PropTypes.string,
};

Form__tabulation.defaultProps = {
  style: {},
  active: false,
  title: "",
  completed: false,
};
